"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function PhysicianCompareMain() {
  function initializePhysicianCompare() {
    var saveButtons = document.getElementsByClassName('doctor-card__btn--save-btn');
    var clearButton = document.querySelector('.doctor-compare__btn--borderless');
    var compareSection = document.querySelector('.doctor-compare');
    if (compareSection) {
      function saveState() {
        var savedItems = Array.from(saveButtons).filter(function (saveButton) {
          return saveButton.querySelector('.temp-checkbox').classList.contains('checked');
        }).map(function (saveButton) {
          return saveButton.getAttribute('data-expand-id');
        });
        var currentSavedItems = JSON.parse(sessionStorage.getItem('savedItems')) || [];
        var updatedSavedItems = Array.from(new Set([].concat(_toConsumableArray(currentSavedItems), _toConsumableArray(savedItems))));
        sessionStorage.setItem('savedItems', JSON.stringify(updatedSavedItems));
      }
      function handleSaveButtonClick(saveButton) {
        var checkbox = saveButton.querySelector('.temp-checkbox');
        var buttonText = saveButton.querySelector('span');
        var dataId = saveButton.getAttribute('data-expand-id');
        var compareCliniciansButton = document.querySelector('.doctor-compare__compare.doctor-compare__btn.doctor-compare__btn--full-sky');
        if (checkbox && buttonText) {
          saveButton.addEventListener('click', function (event) {
            var executeQuery = false;
            var savedItems = JSON.parse(sessionStorage.getItem('savedItems')) || [];
            if (checkbox.classList.contains('checked')) {
              checkbox.classList.remove('checked');
              buttonText.textContent = 'Compare';
              savedItems = savedItems.filter(function (item) {
                return item !== dataId;
              });
              if ($('.doctor-compare__checkbox').hasClass("checked")) {
                executeQuery = true;
              }
            } else {
              checkbox.classList.add('checked');
              buttonText.textContent = 'Compare';
              if (!savedItems.includes(dataId)) {
                savedItems.push(dataId);
              }
            }
            if (savedItems.length > 6 || savedItems.length == 1) {
              compareCliniciansButton.style.backgroundColor = '#dcdcdc';
              compareCliniciansButton.disabled = true;
              compareCliniciansButton.cursor = 'unset';
              compareCliniciansButton.textDecoration = 'none';
            } else {
              compareCliniciansButton.style.backgroundColor = '#00a9e0';
              compareCliniciansButton.disabled = false;
              compareCliniciansButton.cursor = 'pointer';
              compareCliniciansButton.textDecoration = 'underline';
            }
            sessionStorage.setItem('savedItems', JSON.stringify(savedItems));
            updateCheckedCount();
            if (executeQuery) {
              $('.CoveoResultList').coveo('executeQuery');
              if (savedItems.length < 1) {
                $('.doctor-compare__checkbox').click();
              }
            }
          });
        } else {
          console.error('Checkbox or button text element not found inside the save button.');
        }
      }
      function clearAllSaves() {
        Array.from(saveButtons).forEach(function (saveButton) {
          var checkbox = saveButton.querySelector('.temp-checkbox');
          var buttonText = saveButton.querySelector('span');
          if (checkbox && buttonText) {
            checkbox.classList.remove('checked');
            buttonText.textContent = 'Compare';
          }
        });
        sessionStorage.removeItem('savedItems');
        updateCheckedCount();
      }
      Array.from(saveButtons).forEach(handleSaveButtonClick);
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          var checkbox = document.querySelector('.doctor-compare__checkbox');
          if (checkbox.classList.contains('checked')) {
            checkbox.classList.remove('checked');
          }
          clearAllSaves();
          $('.CoveoResultList').coveo('executeQuery');
        });
      } else {
        console.error('Clear button element not found.');
      }
      loadSavedState();
      updateCheckedCount();
    }
  }
  initializePhysicianCompare();
  Coveo.$$(document).on('newResultsDisplayed', function () {
    initializePhysicianCompare();
    console.log("newResultsDisplayed");
  });
  var compareClinicians = document.querySelector('.doctor-compare__compare.doctor-compare__btn.doctor-compare__btn--full-sky');
  var physicianModalData = null;
  var genderFilter = null;
  var isGenderSorted = false;
  var isLocationSorted = false;
  var istreatsAdultsChildrenSorted = false;
  var onlineSchedulingFilter = null;
  var isOnlineSchedulingSort = false;
  var isOffersTelehealthSort = false;
  var isAcceptingNewPatientsSort = false;
  var specialtyFilter = null;
  var isSpecialtySorted = null;
  var activeFilters = []; // move to session
  if (compareClinicians) {
    compareClinicians.addEventListener('click', function () {
      // Retrieve the item IDs from session storage
      var savedItems = sessionStorage.getItem('savedItems');
      if (!savedItems) {
        console.error('No saved items found in session storage.');
        return;
      }
      var itemIDs = JSON.parse(savedItems);
      if (itemIDs.length === 0) {
        console.error('The saved items list is empty.');
        return;
      }
      var queryString = itemIDs.map(function (id) {
        return "itemID=".concat(id);
      }).join('&');
      physicianModalData = null;
      // fetch('https://dev2.ynhhs.org/getphysiciansforcomparison.json');
      fetch("/api/sitecore/physicians/GetPhysiciansForComparison?".concat(queryString)).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.json();
      }).then(function (data) {
        physicianModalData = data;
        GeneratePhysicianData(data);
      }).catch(function (error) {
        console.error('There was a problem with the fetch operation:', error);
      });
    });
  }
  function buildDataPointList(data) {
    // Return "N/A" if the data is an empty string or does not contain any delimiters
    if (typeof data === 'string' && data.trim().length === 0) {
      return "<p>N/A</p>";
    }

    // Split the data string by either comma or semicolon and trim the resulting elements
    var dataArray = data.split(/[,;]/).map(function (i) {
      return i.trim();
    }).filter(function (i) {
      return i.length > 0;
    });

    // Return "N/A" if the resulting array is empty
    if (dataArray.length === 0) {
      return "<p>N/A</p>";
    }
    if (dataArray.length > 4) {
      // Returning a shortened list, and modal will include a tooltip
      return "<ul>".concat(dataArray.splice(0, 4).map(function (i) {
        return "<li>".concat(i, "</li>");
      }).join(''), "</ul>");
    } else {
      // Returning an unordered list
      return "<ul>".concat(dataArray.map(function (i) {
        return "<li>".concat(i, "</li>");
      }).join(''), "</ul>");
    }
  }
  function buildDataPointListTooltip(data) {
    // builds the tooltip and button for data lists with execsive length.

    if (typeof data === 'string' && data.length === 0 || data.split(',').length < 5) {
      return null;
    }
    var html = "<button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--inverted-navy doctor-compare__modal-table-list-tooltip--btn\">View full list</button>\n        <div class=\"doctor-compare__modal-table-list-tooltip\">\n          <ul>".concat(data.split(',').map(function (i) {
      return "<li>".concat(i.trim(), "</li>");
    }).join(''), "</ul>\n          <button type=\"button\" class=\"doctor-compare__modal-table-list-tooltip--close\" aria-label=\"Close tooltip\">\n            <svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\">\n              <g fill=\"none\" fill-rule=\"evenodd\">\n                <path d=\"M0 0h22v22H0z\" />\n                <path d=\"M5.243 5.243a.688.688 0 0 1 .972 0L11 10.028l4.785-4.785a.687.687 0 1 1 .972.972L11.972 11l4.785 4.785a.688.688 0 1 1-.972.972L11 11.972l-4.785 4.785a.687.687 0 0 1-.972-.972L10.028 11 5.243 6.215a.688.688 0 0 1 0-.972z\"\n                      stroke=\"#1E1E1E\" stroke-width=\".5\" fill=\"#1E1E1E\" />\n              </g>\n            </svg>\n          </button>\n        </div>");
    return html;
  }
  function generatePhysicianHTML(physician) {
    // debugger;
    console.log(physician);
    // const genderTemplate = document.getElementById('gender-template').innerHTML;
    var genderTemplate = document.getElementById('physician-row-template').innerHTML;
    var onlineSchedulingIcon = physician.BookOnline ? "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 512 512\">\n          <!--!Font Awesome Free 6.6.0 by fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n          <path fill=\"#00a9e0\" d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z\"></path>\n        </svg>" : "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g fill=\"none\" fill-rule=\"evenodd\">\n              <path d=\"M0 0h24v24H0z\" />\n              <path d=\"M3.303 3.33a1.038 1.038 0 0 1 1.466 0l7.218 7.207 7.217-7.207a1.038 1.038 0 0 1 1.764.45c.094.366-.02.755-.298 1.013L13.452 12l7.218 7.207a1.034 1.034 0 0 1-.45 1.76 1.038 1.038 0 0 1-1.016-.297l-7.217-7.207-7.218 7.207a1.038 1.038 0 0 1-1.44-.025 1.034 1.034 0 0 1-.026-1.438L10.521 12 3.303 4.793a1.034 1.034 0 0 1 0-1.463z\"\n                    fill=\"#979797\" />\n          </g>\n        </svg>";
    var bookOnlineBtn = "<a class=\"doctor-compare__btn doctor-compare__btn--full-navy\" href=\"".concat(physician.BookOnline, "\">\n        <svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g transform=\"matrix(1, 0, 0, 1, -725.0000108033419, -181.3750027026981)\"\n              filter=\"url(#ewwixwa1ca)\"\n              fill=\"#FFF\"\n              fill-rule=\"evenodd\">\n            <path d=\"M750.459 185.709h-3.521v-.813a1.896 1.896 0 0 0-3.792 0v.813h-10.291l-.001-.813a1.895 1.895 0 1 0-3.792 0v.813h-3.52a.541.541 0 0 0-.542.541v18.959a.542.542 0 0 0 .541.541h24.918a.542.542 0 0 0 .541-.541V186.25a.542.542 0 0 0-.541-.541zm-6.23-.813a.813.813 0 0 1 1.625 0v2.166a.812.812 0 1 1-1.625 0v-2.166zm-14.084 0h.001a.812.812 0 1 1 1.625 0v2.166a.813.813 0 0 1-1.625 0v-2.166zm-1.083 1.895v.272a1.896 1.896 0 0 0 3.792 0v-.272h10.291v.272h.001a1.895 1.895 0 1 0 3.792 0v-.272h2.978v3.25h-23.832v-3.25h2.978zm-2.978 17.875v-13.541h23.832v13.541h-23.832zm17.316-9.605a.57.57 0 0 1-.205.387l-5.43 4.859a.571.571 0 0 1-.365.132h-.08a.572.572 0 0 1-.395-.252l-2.144-2.715a.572.572 0 1 1 .95-.63l1.789 2.184 4.944-4.452a.572.572 0 0 1 .805.068.572.572 0 0 1 .13.42z\" />\n          </g>\n        </svg>\n        <span>Book an Appointment</span>\n      </a>");
    var bookByPhoneBtn = "<a class=\"doctor-compare__btn doctor-compare__btn--full-navy\" href=\"tel:".concat(physician.Telephone, "\">\n        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g transform=\"matrix(1, 0, 0, 1, -725.5434068075327, -242.67749385055137)\"\n              filter=\"url(#g197e87g6a)\" fill=\"#ffffff\"\n              fill-rule=\"nonzero\">\n            <path d=\"M735.62 250.189a2.244 2.244 0 0 0 .022-2.26l-2.667-4.61c-.155-.267-.455-.384-.729-.283l-3.174 1.163c-1.617.589-2.51 2.49-2.01 4.28 1.271 4.108 3.422 7.82 6.27 10.825 2.733 3.13 6.11 5.495 9.846 6.893.298.105.61.158.922.158 1.35-.008 2.545-.96 2.972-2.367l1.058-3.49a.726.726 0 0 0-.258-.8l-4.193-2.933a1.745 1.745 0 0 0-2.055.024l-1.335.979a.575.575 0 0 1-.67.018c-.992-.679-1.91-1.48-2.737-2.385a16.827 16.827 0 0 1-2.17-3.01.74.74 0 0 1 .018-.735l.89-1.467zm-1.044-.766-.89 1.468a2.24 2.24 0 0 0-.04 2.23 18.177 18.177 0 0 0 2.349 3.255c.896.98 1.889 1.847 2.961 2.583a1.74 1.74 0 0 0 2.03-.043l1.334-.979a.58.58 0 0 1 .686-.008l3.778 2.644-.904 2.978c-.314 1.066-1.347 1.658-2.322 1.33-3.545-1.33-6.748-3.578-9.339-6.553-2.705-2.849-4.75-6.37-5.96-10.267-.295-1.071.242-2.205 1.21-2.553l2.71-.993 2.405 4.154a.75.75 0 0 1-.008.754z\" />\n          </g>\n        </svg>\n        <span>Call for an Appointment</span>\n      </a>");
    var bookingBtn = physician.AcceptingNewPatients ? physician.BookOnline ? bookOnlineBtn : physician.Telephone ? bookByPhoneBtn : null : null;
    var offersTelehealthIcon = physician.OffersTelehealth.toLowerCase() == 'yes' ? "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 512 512\">\n          <!--!Font Awesome Free 6.6.0 by fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n          <path fill=\"#00a9e0\" d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z\"></path>\n        </svg>" : "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g fill=\"none\" fill-rule=\"evenodd\">\n              <path d=\"M0 0h24v24H0z\" />\n              <path d=\"M3.303 3.33a1.038 1.038 0 0 1 1.466 0l7.218 7.207 7.217-7.207a1.038 1.038 0 0 1 1.764.45c.094.366-.02.755-.298 1.013L13.452 12l7.218 7.207a1.034 1.034 0 0 1-.45 1.76 1.038 1.038 0 0 1-1.016-.297l-7.217-7.207-7.218 7.207a1.038 1.038 0 0 1-1.44-.025 1.034 1.034 0 0 1-.026-1.438L10.521 12 3.303 4.793a1.034 1.034 0 0 1 0-1.463z\"\n                    fill=\"#979797\" />\n          </g>\n        </svg>";
    var acceptingNewPatientsIcon = physician.AcceptingNewPatients === true || physician.AcceptingNewPatients.toString().toLowerCase() == 'yes' ? "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 512 512\">\n          <!--!Font Awesome Free 6.6.0 by fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n          <path fill=\"#00a9e0\" d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z\"></path>\n        </svg>" : "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g fill=\"none\" fill-rule=\"evenodd\">\n              <path d=\"M0 0h24v24H0z\" />\n              <path d=\"M3.303 3.33a1.038 1.038 0 0 1 1.466 0l7.218 7.207 7.217-7.207a1.038 1.038 0 0 1 1.764.45c.094.366-.02.755-.298 1.013L13.452 12l7.218 7.207a1.034 1.034 0 0 1-.45 1.76 1.038 1.038 0 0 1-1.016-.297l-7.217-7.207-7.218 7.207a1.038 1.038 0 0 1-1.44-.025 1.034 1.034 0 0 1-.026-1.438L10.521 12 3.303 4.793a1.034 1.034 0 0 1 0-1.463z\"\n                    fill=\"#979797\" />\n          </g>\n        </svg>";
    var languageSpoken = buildDataPointList(physician.Languages);
    console.log("Language Spoken", languageSpoken);
    var view = {
      ID: physician.ID,
      ImageUrl: physician.ImageUrl,
      FullName: physician.FullName,
      BookingBtn: bookingBtn,
      Url: physician.Url,
      Location: physician.Location,
      Specialties: buildDataPointList(physician.Specialties),
      SpecialtiesTooltip: buildDataPointListTooltip(physician.Specialties),
      Subspecialties: buildDataPointList(physician.Subspecialties),
      SubspecialtiesTooltip: buildDataPointListTooltip(physician.Subspecialties),
      ConditionsTreatments: buildDataPointList(physician.ConditionsTreatments),
      ConditionsTreatmentsTooltip: buildDataPointListTooltip(physician.ConditionsTreatments),
      InsuranceAccepted: buildDataPointList(physician.InsuranceAccepted),
      InsuranceAcceptedTooltip: buildDataPointListTooltip(physician.InsuranceAccepted),
      Gender: physician.Gender,
      LanguagesSpoken: buildDataPointList(physician.Languages),
      LanguagesSpokenTooltip: buildDataPointListTooltip(physician.Languages),
      DeliveryNetworks: buildDataPointList(physician.DeliveryNetworks),
      DeliveryNetworksTooltip: buildDataPointListTooltip(physician.DeliveryNetworks),
      TreatsAdultsChildren: physician.TreatsAdultsChildren,
      OnlineSchedulingIcon: onlineSchedulingIcon,
      OnlineScheduling: physician.OnlineScheduling,
      OffersTelehealthIcon: offersTelehealthIcon,
      OffersTelehealth: physician.OffersTelehealth,
      AcceptingNewPatientsIcon: acceptingNewPatientsIcon,
      AcceptingNewPatients: physician.AcceptingNewPatients
    };
    console.log(view);
    return Mustache.render(genderTemplate, view);
  }
  function GeneratePhysicianData(data) {
    var genderFilterEnabled = $('.doctor-compare__condition[data-column="gender"]').hasClass('active');
    var onlineSchedulingFilterEnabled = $('.doctor-compare__condition[data-column="online-scheduling"]').hasClass('active');
    var specialtiesFilterEnabled = $('.doctor-compare__condition[data-column="specialties"]').hasClass('active');
    var container = document.querySelector('.doctor-compare__modal-table');
    container.innerHTML = "<div class=\"doctor-compare__modal-table-row\">\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__profile-header\">\n                  Saved Clinicians\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table--col--1 doctor-compare__modal-table-header\" data-column=\"empty\"></div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table--col--2 doctor-compare__modal-table-header\" data-column=\"empty\"></div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table--col--3 doctor-compare__modal-table-header\" data-column=\"empty\"></div>\n              \n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"location\">\n                  <span>Location</span>\n                  <div id=\"location\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"specialties\">\n                  <span>Specialties</span>\n\n                  <div id=\"specialties\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"subspecialties\">\n                  <span>Subspecialties</span>\n\n                  <div id=\"subspecialties\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"conditions-treatments\">\n                  <span>Conditions &amp; Treatments</span>\n\n                  <div id=\"conditions-treatments\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"insurance-accepted\">\n                  <span>Insurance Accepted</span>\n\n                  <div id=\"insurance-accepted\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"gender\">\n                  <span>Gender</span>\n                  <div id=\"gender\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"languages\">\n                  <span>Languages Spoken</span>\n\n                  <div id=\"languages\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header\" data-column=\"delivery-network\">\n                  <span>Delivery Network</span>\n\n                  <div id=\"delivery-network\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"treats-adults-children\">\n                  <span>Treats Adults/Children</span>\n\n                  <div id=\"treats-adults-children\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"online-scheduling\">\n                  <span>Online Scheduling</span>\n\n                  <div id=\"online-scheduling\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"offers-telehealth\">\n                  <span>Offers Telehealth</span>\n\n                  <div id=\"offers-telehealth\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n              <div class=\"doctor-compare__modal-table--col doctor-compare__modal-table-header doctor-compare__modal-table-header--sortable\" data-column=\"accepting-new-patients\">\n                  <span>Accepting New Patients</span>\n\n                  <div id=\"accepting-new-patients\">\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 7.35 6.667 0 0 7.35z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n\n                      <button type=\"button\" class=\"doctor-compare__btn doctor-compare__btn--sort\">\n                          <svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\">\n                              <path d=\"M13.333 0 6.667 7.35 0 0z\" fill=\"#979797\" fill-rule=\"nonzero\" />\n                          </svg>\n                      </button>\n                  </div>\n              </div>\n          </div>";
    if (Array.isArray(data)) {
      data.forEach(function (physicians) {
        var html = generatePhysicianHTML(physicians);
        container.insertAdjacentHTML('beforeend', html);
      });
    } else {
      console.error('Unexpected response format.');
    }

    // Adding click event to tooltips for excessively long lists:
    var showTooltipBtns = document.querySelectorAll('.doctor-compare__modal-table-list-tooltip--btn');
    showTooltipBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var tooltip = e.target.nextElementSibling;
        tooltip.classList.toggle('doctor-compare__modal-table-list-tooltip--open');
      });
    });
    var showTooltipCloseBtns = document.querySelectorAll('.doctor-compare__modal-table-list-tooltip--close');
    showTooltipCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var tooltip = e.target.closest('.doctor-compare__modal-table-list-tooltip');
        console.log(tooltip);
        tooltip.classList.toggle('doctor-compare__modal-table-list-tooltip--open');
      });
    });

    //Sorting for Location
    var intervalLocation = setInterval(function () {
      var locationFilter = document.querySelector('div#location');
      if (locationFilter != null) {
        clearInterval(intervalLocation);
        locationFilter.addEventListener('click', function () {
          var a = data.sort(function (a, b) {
            if (a.Location < b.Location) {
              return !isLocationSorted ? -1 : 1;
            }
            if (a.Location > b.Location) {
              return isLocationSorted ? -1 : 1;
            }
            return 0;
          });
          isLocationSorted = !isLocationSorted;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    //Sorting for Gender
    var intervalGender = setInterval(function () {
      var genderFilter = document.querySelector('div#gender');
      if (genderFilter != null) {
        clearInterval(intervalGender);
        genderFilter.addEventListener('click', function () {
          var a = data.sort(function (a, b) {
            if (a.Gender < b.Gender) {
              return !isGenderSorted ? -1 : 1;
            }
            if (a.Gender > b.Gender) {
              return isGenderSorted ? -1 : 1;
            }
            return 0;
          });
          isGenderSorted = !isGenderSorted;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    //Sorting for onlinescheduling
    var intervalOnlineScheduling = setInterval(function () {
      var onlineSchedulingFilter = document.querySelector('div#online-scheduling');
      if (onlineSchedulingFilter != null) {
        clearInterval(intervalOnlineScheduling);
        onlineSchedulingFilter.addEventListener('click', function () {
          console.log('Starting CLicks');
          var a = data.sort(function (a, b) {
            if (a.OnlineScheduling < b.OnlineScheduling) {
              return !isOnlineSchedulingSort ? -1 : 1;
            }
            if (a.OnlineScheduling > b.OnlineScheduling) {
              return isOnlineSchedulingSort ? -1 : 1;
            }
            return 0;
          });
          isOnlineSchedulingSort = !isOnlineSchedulingSort;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    //Sorting for Offers Telehealth
    var intervalOffersTelehealthFilter = setInterval(function () {
      var OffersTelehealthFilter = document.querySelector('div#offers-telehealth');
      if (OffersTelehealthFilter) {
        clearInterval(intervalOffersTelehealthFilter);
        OffersTelehealthFilter.addEventListener('click', function () {
          var a = data.sort(function (a, b) {
            if (a.OffersTelehealth < b.OffersTelehealth) {
              return !isOffersTelehealthSort ? -1 : 1;
            }
            if (a.OffersTelehealth > b.OffersTelehealth) {
              return isOffersTelehealthSort ? -1 : 1;
            }
            return 0;
          });
          isOffersTelehealthSort = !isOffersTelehealthSort;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    //Sorting for accepting new patients
    var intervalOfAcceptingNewPatientsFilter = setInterval(function () {
      var acceptingNewPatientsFilter = document.querySelector('div#accepting-new-patients');
      if (acceptingNewPatientsFilter) {
        clearInterval(intervalOfAcceptingNewPatientsFilter);
        acceptingNewPatientsFilter.addEventListener('click', function () {
          var a = data.sort(function (a, b) {
            if (a.AcceptingNewPatients < b.AcceptingNewPatients) {
              return !isAcceptingNewPatientsSort ? -1 : 1;
            }
            if (a.AcceptingNewPatients > b.AcceptingNewPatients) {
              return isAcceptingNewPatientsSort ? -1 : 1;
            }
            return 0;
          });
          isAcceptingNewPatientsSort = !isAcceptingNewPatientsSort;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    //Sorting for Treats Adults/Children
    var intervaltreatsAdultsChildren = setInterval(function () {
      var treatsAdultsChildrenFilter = document.querySelector('div#treats-adults-children');
      if (treatsAdultsChildrenFilter) {
        clearInterval(intervaltreatsAdultsChildren);
        treatsAdultsChildrenFilter.addEventListener('click', function () {
          var a = data.sort(function (a, b) {
            if (a.TreatsAdultsChildren < b.TreatsAdultsChildren) {
              return !istreatsAdultsChildrenSorted ? -1 : 1;
            }
            if (a.TreatsAdultsChildren > b.TreatsAdultsChildren) {
              return istreatsAdultsChildrenSorted ? -1 : 1;
            }
            return 0;
          });
          istreatsAdultsChildrenSorted = !istreatsAdultsChildrenSorted;
          GeneratePhysicianData(a);
          UpdateTableCells();
        });
      }
    }, 1000);

    // Adding click event to remove buttons
    var removePhysicianBtns = document.querySelectorAll('.doctor-compare__btn.doctor-compare__btn--remove');
    if (removePhysicianBtns) {
      if (removePhysicianBtns.length >= 2) {
        removePhysicianBtns.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            var physician = e.target.dataset.physician;
            if (physician) {
              // getting table row
              var row = e.target.closest('.doctor-compare__modal-table-row');
              RemovePhysician(physician, row);
              updateCheckedCount();
            }
          });
        });
      }
    }
  }
  function RemovePhysician(physician, row) {
    console.log("Removing physician: ".concat(physician));
    //removing table row
    row.remove();

    // getting session data
    var savedItems = JSON.parse(sessionStorage.getItem('savedItems')) || [];
    console.log(savedItems);
    // finding index of physician to remove
    var index = savedItems.indexOf(physician);
    console.log("index: ".concat(index));
    // updating array of physicians
    var removedItem = savedItems.splice(index, 1);
    console.log(savedItems);
    // updating session with new array
    sessionStorage.setItem('savedItems', JSON.stringify(savedItems));

    // updating coveo results
    loadSavedState();
    updateCheckedCount();
    $('.CoveoResultList').coveo('executeQuery');
  }
  function loadSavedState() {
    var savedItems = JSON.parse(sessionStorage.getItem('savedItems')) || [];
    var saveButtons = document.getElementsByClassName('doctor-card__btn--save-btn');
    Array.from(saveButtons).forEach(function (saveButton) {
      var checkbox = saveButton.querySelector('.temp-checkbox');
      var buttonText = saveButton.querySelector('span');
      var dataId = saveButton.getAttribute('data-expand-id');
      if (checkbox && buttonText && savedItems.includes(dataId)) {
        checkbox.classList.add('checked');
        buttonText.textContent = 'Compare';
      } else {
        checkbox.classList.remove('checked');
        buttonText.textContent = 'Compare';
      }
    });
  }
  function updateCheckedCount() {
    var savedItems = JSON.parse(sessionStorage.getItem('savedItems')) || [];
    var filterLabel = document.querySelector('label[for="filter-comparison"] span');
    var compareCliniciansLabel = document.querySelector('.doctor-compare button.doctor-compare__compare.doctor-compare__btn.doctor-compare__btn--full-sky span.doctor-compare__compare-count');
    var compareSection = document.querySelector('.doctor-compare');
    var compareModel = document.querySelector('.doctor-compare__modal.modal');
    var checkedCount = savedItems.length;
    var searchBar = document.querySelector('.custom-search-section-new');
    var compareCliniciansButton = document.querySelector('.doctor-compare__compare.doctor-compare__btn.doctor-compare__btn--full-sky');
    var filterButton = document.querySelector('.coveo-dropdown-header-wrapper');
    if (savedItems.length > 6 || savedItems.length == 1) {
      compareCliniciansButton.style.backgroundColor = '#dcdcdc';
      compareCliniciansButton.disabled = true;
      compareCliniciansButton.style.cursor = 'unset';
      compareCliniciansButton.style.textDecoration = 'none';
    } else {
      compareCliniciansButton.style.backgroundColor = '#00a9e0';
      compareCliniciansButton.disabled = false;
      compareCliniciansButton.style.cursor = 'pointer';
      compareCliniciansButton.style.textDecoration = 'underline';
    }
    if (filterLabel && compareCliniciansLabel) {
      filterLabel.textContent = "(".concat(checkedCount, ")");
      compareCliniciansLabel.textContent = "(".concat(checkedCount, "/6)");
    } else {
      console.error('Filter label element not found.');
    }
    if (compareSection) {
      compareSection.style.display = checkedCount >= 1 ? 'block' : 'none';
      searchBar.style.marginBottom = checkedCount >= 1 ? 'unset' : '3rem';
      if (checkedCount < 1) compareModel.classList.remove('is-active');
      if (checkedCount >= 1) {
        if (filterButton) {
          filterButton.classList.add('is-compare');
        }
      } else {
        if (filterButton) {
          filterButton.classList.remove('is-compare');
        }
      }
    } else {
      console.error('Compare section element not found.');
    }
  }
  if (compareClinicians) {
    compareClinicians.addEventListener('click', function (event) {
      var compareModel = document.querySelector('.doctor-compare__modal.modal');
      compareModel.classList.add('is-active');
    });
  }
  var executeQueryOnClose = false;
  var closeModel = document.querySelector('.doctor-compare__btn--close');
  if (closeModel) {
    closeModel.addEventListener('click', function (event) {
      var compareModel = document.querySelector('.doctor-compare__modal.modal');
      compareModel.classList.remove('is-active');

      // Clear active filters
      activeFilters = [];

      // Remove active class from all buttons
      document.querySelectorAll('.doctor-compare__condition').forEach(function (condition) {
        condition.classList.remove('active');
      });
      // Clear displayed data in the table
      document.querySelectorAll('.doctor-compare__modal-table *[data-column]').forEach(function (cell) {
        cell.classList.remove('doctor-compare__modal-table--col--1', 'doctor-compare__modal-table--col--2', 'doctor-compare__modal-table--col--3');
      });
      $('.CoveoResultList').coveo('executeQuery');
    });
  }
  var returnToSearchbtn = document.querySelector('.doctor-compare__btn.doctor-compare__btn--inverted-navy');
  if (returnToSearchbtn) {
    returnToSearchbtn.addEventListener('click', function (event) {
      var compareModel = document.querySelector('.doctor-compare__modal.modal');
      compareModel.classList.remove('is-active');
      // Clear active filters
      activeFilters = [];

      // Remove active class from all buttons
      document.querySelectorAll('.doctor-compare__condition').forEach(function (condition) {
        condition.classList.remove('active');
      });
      // Clear displayed data in the table
      document.querySelectorAll('.doctor-compare__modal-table *[data-column]').forEach(function (cell) {
        cell.classList.remove('doctor-compare__modal-table--col--1', 'doctor-compare__modal-table--col--2', 'doctor-compare__modal-table--col--3');
      });
      $('.CoveoResultList').coveo('executeQuery');
    });
  }
  var physicianCompareConditions = document.querySelector('.doctor-compare__conditions');
  if (physicianCompareConditions) {
    var physicianCompareCondition = physicianCompareConditions.querySelectorAll('.doctor-compare__condition');
    physicianCompareCondition.forEach(function (condition) {
      condition.addEventListener('click', function (event) {
        // updating state of filter button:
        var filter = event.target.parentElement;
        var dataPoint = filter.dataset.column;
        if (!filter.classList.contains('active')) {
          // filter was turned on:
          filter.classList.add('active');

          // TO DO: Limit active filters to max of 3.
          if (activeFilters.length >= 3) {
            // removing first/oldest filter
            var oldestFilter = activeFilters.splice(0, 1);

            // turning off oldest filter button
            var oldFilterBtn = document.querySelector(".doctor-compare__condition[data-column=\"".concat(oldestFilter, "\"]"));
            oldFilterBtn.classList.remove('active');

            // hiding old data column
            var selector = '.doctor-compare__modal-table *[data-column="' + oldestFilter + '"]';
            var tableCells = document.querySelectorAll(selector);
            tableCells.forEach(function (cell) {
              cell.classList.remove("doctor-compare__modal-table--col--1");
            });
          }

          //adding filter to array of active filters
          activeFilters.push(dataPoint);
        } else {
          // filter was turned off:
          filter.classList.remove('active');

          // getting index of active filter:
          var index = activeFilters.indexOf(dataPoint);

          // removing filter from list of active:
          activeFilters.splice(index, 1);

          // hiding data cell
          var _selector = '.doctor-compare__modal-table *[data-column="' + dataPoint + '"]';
          var _tableCells = document.querySelectorAll(_selector);
          _tableCells.forEach(function (cell) {
            cell.classList.remove("doctor-compare__modal-table--col--".concat(index + 1));
          });
        }
        UpdateTableCells();
      });
    });
  }
  function UpdateTableCells() {
    // Updates which columns are visible based on what filters are with the activeFilters array.

    // looping through activeFilters and applying a `doctor-compare__modal-table-col--*` based on the index of the filter:
    activeFilters.forEach(function (filter) {
      // selecting table cells with matching filter data
      var selector = '.doctor-compare__modal-table *[data-column="' + filter + '"]';
      var tableCells = document.querySelectorAll(selector);
      var index = activeFilters.indexOf(filter);

      //hiding empty cells:
      var emptyCells = document.querySelectorAll(".doctor-compare__modal-table--col--".concat(index + 1, "[data-column=\"empty\"]"));
      emptyCells.forEach(function (cell) {
        cell.classList.remove("doctor-compare__modal-table--col--".concat(index + 1));
      });
      tableCells.forEach(function (cell) {
        // first cleaning up the table cell of any existing column classes
        for (var step = 0; step < 3; step++) {
          cell.classList.remove("doctor-compare__modal-table--col--".concat(step + 1));
        }

        // adding column class if it does not have if
        cell.classList.add("doctor-compare__modal-table--col--".concat(index + 1));
      });
    });

    // Need to fill in with empty columns:
    if (activeFilters.length < 3) {
      var selector = '.doctor-compare__modal-table-row';
      var tableRows = document.querySelectorAll(selector);
      tableRows.forEach(function (row) {
        // looping over each row and adjusting the empty cells on that row.

        // Getting empty cells
        var empptyCells = row.querySelectorAll('.doctor-compare__modal-table--col[data-column="empty"]');

        // Showing the empty cells at the end of the row:
        for (var step = activeFilters.length; step < 3; step++) {
          empptyCells[step].classList.add("doctor-compare__modal-table--col--".concat(step + 1));
        }
      });
    }
  }
}
window.addEventListener('load', function (event) {
  setTimeout(function () {
    PhysicianCompareMain();
  }, 1000);
  var maninNav = document.querySelector('.main-search-nav').offsetHeight || 0;
  var stickyLinks = document.querySelector('.doctor-compare');
  if (stickyLinks) {
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      if (scrollY > maninNav) {
        stickyLinks.classList.add('fixed-menu');
      } else {
        stickyLinks.classList.remove('fixed-menu');
      }
    });
  }
});